import React, {
    useEffect,
    useRef,
    useState
} from 'react';
import PropTypes from 'prop-types';

import {
    useCreateCompanySet,
    useEditCompanySet
} from '../../hooks/companySetHooks.js';


EditCompanySet.propTypes = {
    currentName: PropTypes.string,
    companySetId: PropTypes.number,
    validateCompanySetName: PropTypes.func.isRequired,
    onUpdateCompanySet: PropTypes.func.isRequired,
    onCancelCompanySetName: PropTypes.func.isRequired
};

export default function EditCompanySet({currentName, companySetId, validateCompanySetName, onUpdateCompanySet, onCancelCompanySetName}) {

    const [companySetName, setCompanySetName] = useState(currentName || '');
    const {mutate: createCompanySet} = useCreateCompanySet();
    const {mutate: editCompanySet} = useEditCompanySet();
    const inputRef = useRef();
    const [showValidationError, setShowValidationError] = useState(false);

    const companySetNameValidationError = validateCompanySetName(companySetName);

    useEffect(() => {
        // This effect will focus the input field when first shown.
        inputRef.current.focus();
    });

    function onKeyDown(e) {
        if (e.key === 'Enter') {
            onSaveCompanySetName();
        } else if (e.key === 'Escape') {
            onCancelCompanySetName();
            e.stopPropagation();
        }
    }

    function onCompanySetChange(e) {
        setCompanySetName(e.target.value);
        setShowValidationError(false);
    }

    function onSaveCompanySetName() {

        if (companySetNameValidationError) {
            setShowValidationError(true);
            return;
        } else {
            setShowValidationError(false);
        }

        if (companySetId) {
            editCompanySet({
                name: companySetName,
                currentName: currentName,
                companySetId: companySetId
            }, {
                onSuccess: () => {
                    onUpdateCompanySet(companySetName);
                }
            });
        } else {
            createCompanySet({
                name: companySetName
            }, {
                onSuccess: () => {
                    onUpdateCompanySet(companySetName);
                }
            });
        }
    }

    return (
        <div className='tlw-cursor-pointer tlw-border-0 tlw-border-b tlw-border-solid tlw-border-gray-300 tlw-px-7.5 tlw-py-5'>
            <div className='tlw-flex tlw-items-center'>
                <input
                    className='focus_visible_tlw-outline-none tlw-m-0 tlw-mr-2.5 tlw-grow tlw-border-0 tlw-border-b tlw-border-gray-500 tlw-pb-0 tlw-pl-0 focus_tlw-outline-none'
                    ref={inputRef}
                    value={companySetName}
                    onKeyDown={onKeyDown}
                    onChange={onCompanySetChange} />
                <button
                    className={`tlw-mr-5 tlw-w-11 tlw-border-0 tlw-bg-transparent tlw-bg-none tlw-p-0 ${companySetNameValidationError ? 'tlw-cursor-not-allowed tlw-opacity-65' : ''}`}
                    onClick={onSaveCompanySetName}>
                    <span className='fa fa-fw fa-check fa-color' />
                </button>
                <button
                    className='tlw-w-11 tlw-border-0 tlw-bg-transparent tlw-bg-none tlw-p-0'
                    onClick={() => onCancelCompanySetName()}>
                    <span className='fa fa-fw fa-times fa-color' />
                </button>

            </div>

            {showValidationError && companySetNameValidationError &&
                <span
                    className='tlw-text-sm tlw-text-red-500'>
                    {companySetNameValidationError}
                </span>
            }
        </div>
    );
}
